var PracticeErrorCode = /*#__PURE__*/function (PracticeErrorCode) {
  PracticeErrorCode[PracticeErrorCode["TOO_MANY_CONNECTIONS"] = 28] = "TOO_MANY_CONNECTIONS";
  PracticeErrorCode[PracticeErrorCode["INVALID_PRACTICE_ID"] = 4] = "INVALID_PRACTICE_ID";
  PracticeErrorCode[PracticeErrorCode["ALREADY_CONNECTED"] = 2] = "ALREADY_CONNECTED";
  PracticeErrorCode[PracticeErrorCode["COUNTRY_NOT_SUPPORTED_API"] = 5] = "COUNTRY_NOT_SUPPORTED_API";
  PracticeErrorCode[PracticeErrorCode["COUNTRY_NOT_SUPPORTED_LIBRE"] = 6] = "COUNTRY_NOT_SUPPORTED_LIBRE";
  PracticeErrorCode[PracticeErrorCode["PRACTICE_NOT_FOUND"] = 27] = "PRACTICE_NOT_FOUND";
  return PracticeErrorCode;
}(PracticeErrorCode || {});
export default PracticeErrorCode;